const GreyDot = () => {
  return (
    <div className="relative w-34 h-34 sm:w-43 sm:h-43 rounded-full bg-[#dddddd]">
      <svg
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-15 sm:w-20 h-auto"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9.75113" cy="6.8566" r="5.94486" stroke="#FEFEFE" strokeWidth="0.831273" />
        <path
          d="M0.427734 19.0049C2.1268 15.5753 5.66282 13.2174 9.74957 13.2174C13.8363 13.2174 17.3723 15.5753 19.0714 19.0049"
          stroke="#FEFEFE"
          strokeWidth="0.831273"
        />
      </svg>
    </div>
  );
};
export default GreyDot;
